<template>
  <BoxCard>
    <template #header>
      <div class="flex justify-between">
        <p>Attendance</p>
      </div>
    </template>
    <template #content>
      <div class="mb-5">
        <div class="flex gap-5">
          <div class="p-2.5 rounded-lg bg-indigo-200 h-50">
            <UserIcon class="h-7 w-7 text-vice-medium-blue"></UserIcon>
          </div>
          <div>
            <p class="text-xs leading-6 font-semibold text-vice-medium-blue">Participants</p>
            <div class="flex gap-3 items-end">
              <p class="text-xs font-medium text-dark-grey leading-6">
                <span class="text-xl text-gray-900">
                  <!-- Data from SessionOpenPlacesMixin -->
                  {{ openParticipantsPositions }}
                </span>
                open /
                <span class="text-bold">
                  <span class="font-bold">
                    <!-- Data from SessionOpenPlacesMixin -->
                    {{ maxParticipantsAmount }}
                  </span>
                </span>
                max
              </p>
              <!-- Data from SessionOpenPlacesMixin -->
              <div v-if="!currentSessionIsPrivate" class="italic text-gray-600 text-xs leading-6">
                ({{ maxParticipantsAmount - openParticipantsPositions }} applications)
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="relative w-96 mb-5">
        <hr class="absolute right-6 w-full text-gray-200" />
      </div>
      <div class="mt-12">
        <div class="flex gap-5">
          <div
            class="p-2.5 rounded-lg h-50"
            :class="observer_open_position ? 'bg-vice-light-yellow' : 'bg-vice-light-grey'"
          >
            <EyeIcon
              class="h-7 w-7"
              :class="observer_open_position ? 'text-vice-dark-yellow' : 'text-dark-grey'"
            ></EyeIcon>
          </div>
          <div>
            <p
              class="text-xs leading-6 font-semibold"
              :class="observer_open_position ? 'text-vice-dark-yellow' : 'text-dark-grey'"
            >
              Observers
            </p>
            <div class="flex gap-3 items-end">
              <p class="text-xs font-medium text-dark-grey leading-6">
                <span class="text-xl text-gray-900">
                  <!-- Methods from SessionOpenPlacesMixin -->
                  {{ openObserversPositions }}
                </span>
                open /
                <span class="font-bold">
                  <!-- Method from SessionOpenPlacesMixin -->
                  {{ maxObserversAmount }}
                </span>
                max
              </p>
              <!-- Methods from SessionOpenPlacesMixin -->
              <div v-if="!currentSessionIsPrivate" class="italic text-gray-600 text-xs leading-6">
                ({{ maxObserversAmount - openObserversPositions }} applications)
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
  </BoxCard>
</template>

<script>
import { UserIcon, EyeIcon } from '@heroicons/vue/solid';
import { ref } from 'vue';
import axios from 'axios';
import { Inertia } from '@inertiajs/inertia';
import BoxCard from '@/Components/Cards/BoxCard.vue';
import SessionOpenPlacesMixin from '@/Mixins/SessionOpenPlacesMixin.vue';

export default {
  name: 'AttendanceStats',
  components: {
    BoxCard,
    UserIcon,
    EyeIcon,
  },
  mixins: [SessionOpenPlacesMixin],
  setup() {
    const open = ref(false);
    const userTypeSelected = ref(null);
    return {
      userType,
      open,
      userTypeSelected,
    };
  },
  mounted() {
    this.setOpenPosition();
  },
  props: {
    showApplyButton: Boolean,
    userSessionType: String,
  },
  data() {
    return {
      open_revert_invitation_modal: false,
      user_invites: this.$page.props.session.users,
      participant_open_position: '',
      observer_open_position: '',
      currentSession: this.$page.props.session,
    };
  },
  methods: {
    getUserOpenCount(userInvites, maxCount, type) {
      let countUser = 0;
      for (let i = 0; i <= this.user_invites.length; i++) {
        if (userInvites[i]) {
          // eslint-disable-next-line no-unused-expressions, no-plusplus
          userInvites[i].user_type === type ? countUser++ : '';
        }
      }
      return maxCount - countUser;
    },
    setOpenPosition() {
      this.participant_open_position = this.getUserOpenCount(
        this.$page.props.session.users,
        this.$page.props.session.participant_preferences.max_participants_amount,
        userType.participant,
      );
      this.observer_open_position = this.getUserOpenCount(
        this.$page.props.session.users,
        this.$page.props.session.participant_preferences.max_observers_amount,
        userType.observer,
      );
    },
    applySession() {
      this.open = false;
      this.$emit('userHasApplied', this.userTypeSelected);
      axios
        .post(route('session.apply', this.$page.props.session.id), {
          user_type: this.userTypeSelected,
        })
        .then(() => {
          Inertia.reload({ only: [this.$page.props.users] });
          this.hasApplied = true;
        });
    },
    enableApply(openPosition) {
      return this.showApplyButton && openPosition && !this.$page.props.session.is_private;
    },
    showCount(count) {
      return this.$page.props.session.is_private ? 0 : count;
    },
    getParticipantsCount() {
      const invitedParticipants = _.filter(
        this.$page.props.session.invites,
        (user) => user.user_role == 'participant',
      );
      const acceptedParticipants = _.filter(
        this.$page.props.session.applies,
        (user) => user.user_type == 'participant' && user.accepted_at != null,
      );
      const totalParticipants = invitedParticipants.length + acceptedParticipants.length;
      return totalParticipants;
    },
    getParticipantApplicationsCount() {
      const acceptedParticipants = _.filter(
        this.$page.props.session.applies,
        (user) => user.user_type == 'participant',
      );
      return acceptedParticipants.length;
    },
    getObserversApplicationsCount() {
      const acceptedObserverss = _.filter(
        this.$page.props.session.applies,
        (user) => user.user_type == 'observer',
      );
      return acceptedObserverss.length;
    },
    getObserversCount() {
      const invitedObservers = _.filter(
        this.$page.props.session.invites,
        (user) => user.user_role == 'observer',
      );
      return invitedObservers.length;
    },
  },
};
</script>

<style scoped>
.h-50 {
  height: 50px;
}
</style>
